/** ***********
*
* <signal-source.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
* All rights reserved.
**************/

import { Tracker } from './tracker';

export enum SignalSources {
  GPS = 'gps',
  BEACON = 'beacon',
  NO_GPS = 'no gps',
  UNKNOW = 'unknow',
  EXACTEARTH = 'exactearth',
  AIRSENSE = 'airsense',
  GO2SCAN = 'go2scan',
  ANCHOR = 'anchor',
  SMARTPHONE = 'smartphone'
}

/**
 * Enum for Providers
 */
 export enum SignalSourceProviderValues {
  sensolus = 'Sensolus',
  exactearth = 'exactearth',
  adveez = 'Adveez',
  ffly4u = 'FFLY4U',
  airsense = 'airsense',
  aswarm = 'A-Swarm',
  quuppa = 'QUUPPA',
  trackunit = 'Trackunit',
  sensolus_AH = 'Sensolus AH',
  sensolus_DS = 'Sensolus DS'
}

export interface SignalSourceProvierSettings {
  displayUnit: 'time'|'%';
  displayFixedBatteryIcon: boolean;
  getBattery: (tracker: Tracker) => number | string;
  timeTooLarge: (tracker: Tracker) => boolean;
}

export const TRACKER_MAX_BATTERY_LIFE_MONTHS = 36;
